import { IconNames } from '@blueprintjs/icons';
import { IconButton } from '@strata/react-buttons';
import { DetailLabel, DetailValue } from '@strata/react-label-value-pairs';

interface EditableFieldWithEditButtonProps {
    label: string;
    value: string | undefined;
    onEditClick: () => void;
}

export const EditableFieldWithEditButton = ({
    label,
    value,
    onEditClick,
}: EditableFieldWithEditButtonProps) => (
    <div style={{ width: '33%' }}>
        <DetailLabel label={label} />
        <div className="flex__gap--medium" style={{ alignItems: 'center' }}>
            <DetailValue value={value} />
            <IconButton icon={IconNames.EDIT} title={`Edit ${label}`} onClick={onEditClick} />
        </div>
    </div>
);
